<template>
  <div class="page gallery">
    <button class="close" @click="$router.go(-1)"></button>
    <div class="gallery-container">
      <div class="gallery-items">
        <div class="slide" v-for="(artwork, index) in this.$route.query.artist.artwork.filter(a => a.images.find(i => i.image))" :key="index">
          <div class="slide-image-container">
            <div class="slide-image" :style="'background-image:url(' + encodeURI(artwork.images[0].image.url) + ')'"></div>
          </div>
          <div class="image-caption">
            <strong><i>{{ artwork.title }}</i></strong>
            <p><template v-if="artwork.year">{{artwork.year}}</template> <template v-if="artwork.materials">{{artwork.materials}}</template> <template v-if="artwork.height">{{artwork.height}}</template><template v-if="artwork.width">x{{artwork.width}}</template><template v-if="artwork.depth">x{{artwork.depth}}</template></p>
            <p v-if="artwork.price"><template v-if="!artwork.price.includes('$') && !artwork.price.includes('NFS')">$</template>{{artwork.price}}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="gallery-controls" v-if="this.$route.query.artist.artwork.filter(a => a.images.find(i => i.image)).length > 1">
      <button class="gallery-btn left" @click="galleryPrev"></button>
      <ul class="intro-dots">
        <li v-for="(artwork, index) in this.$route.query.artist.artwork.filter(a => a.images.find(i => i.image))" :key="index" :class="{active: galleryCurrentSlide == index}"></li>
      </ul>
      <button class="gallery-btn right" @click="galleryNext"></button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Gallery',
  data() {
    return {
      galleryCurrentSlide: 0
    };
  },
  mounted() {
    setTimeout(() => {
      mountedReady();
    }, 100);

    let mountedReady = () => {
      this.flickityInit();

      let slideImages = document.querySelectorAll(".slide-image");
      slideImages.forEach(el => {
        let pz = new PinchZoom.default(el, {
          draggableUnzoomed: false
        });
      });
    };
  },
  methods: {
    flickityInit() {
      this.flickity = new Flickity(this.$el.querySelector(".gallery-items"), {
        prevNextButtons: false,
        pageDots: false,
        cellAlign: "center",
        contain: true,
        adaptiveHeight: false
      });
      this.flickity.on("change", () => {
        this.galleryCurrentSlide = this.flickity.selectedIndex;
      });

      if (this.$route.query.index) {
        this.flickity.select(this.$route.query.index, false, true);
      }
    },
    galleryNext() {
      this.flickity.next();
    },
    galleryPrev() {
      this.flickity.previous();
    },
  }
};
</script>

<style lang="less" scoped>
@import '../../css/variables';

.gallery {
  padding-top: 0;
  background-color: #000;
  .close {
    position: absolute;
    top: 17px;
    top: calc(~"17px + env(safe-area-inset-top)");
    right: 20px;
    width: 41px;
    height: 41px;
    z-index: 1;
    background-image: url(../../assets/img/gallery-close-white.svg);
    background-size: 41px 41px;
  }
  .image-caption {
    padding: 15px;
    text-align: center;
    color: #fff;
    line-height: 20px;
  }
  .gallery-items {
    .slide {
      width: 100%;
      height: 100vh;
      height: calc(~'100vh - env(safe-area-inset-top) - 65px');
      .slide-image-container {
        height: calc(~'100% - 150px');
        margin-top: 65px;
      }
      .slide-image {
        height: 100%;
        width: 100%;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
      }
    }
  }
  .gallery-controls {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: absolute;
    bottom: 30px;
    bottom: calc(~"30px + env(safe-area-inset-bottom)");
    width: 100%;
    padding: 0 25px;
    z-index: 1;
    .gallery-btn {
      width: 32px;
      height: 25px;
      &.left {
        background-image: url(../../assets/img/gallery-left-white.svg);
      }
      &.right {
        background-image: url(../../assets/img/gallery-right-white.svg);
      }
    }
    .intro-dots {
      text-align: center;
      li {
        display: inline-block;
        width: 8px;
        height: 8px;
        background-color: #fff;
        opacity: 0.39;
        margin: 0 8px;
        border-radius: 50%;
        cursor: pointer;
        &.active {
          opacity: 1;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Artist/Gallery.vue